<section>
  <h6 class="uk-flex uk-flex-middle"><span class="material-symbols-outlined uk-margin-small-right">settings</span>Chapter settings</h6>
  <div class="uk-margin">
<!--    <label for="chapterName" class="uk-form-label uk-margin-small-bottom">Chapter Name*</label>-->
    <div for="chapterName" class="uk-margin-small-bottom uk-text-muted">Chapter Name*</div>
    <div class="uk-form-controls">
      <input id="chapterName" class="uk-input" [ngModel]="$safeNavigationMigration(fbService.currentSection()?.name)"
             (ngModelChange)="fbService.setSectionName($event)" placeholder="Untitled Chapter">
    </div>
  </div>
  <div class="uk-margin">
    <div for="chapterDescription" class="uk-margin-small-bottom uk-text-muted">Description*</div>
<!--    <label for="chapterDescription" class="uk-form-label uk-margin-small-bottom">Description*</label>-->
    <div class="uk-form-controls">
      <app-rich-text-editor id="chapterDescription" [ngModel]="$safeNavigationMigration(fbService.currentSection()?.description)"
                (ngModelChange)="fbService.setSectionDescription($event)"
                placeholder="Give a short description for the chapter">
      </app-rich-text-editor>
    </div>
  </div>
</section>
